import React, { Component, CSSProperties } from 'react';
import classNames from 'classnames';
import { DROPDOWN_ICON } from '@src/framework/workbench/drawer/image';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Style from './index.less';
import { getTooltipProps } from './index';
import Dropdown from '@tencent/dui/lib/components/Dropdown';

type IFormItemDropdownState = {
    isChecked?: boolean;
};

type IFormItemDropdownProps = {
    checked?: boolean;
    icon: any;
    onClick: any;
    style?: CSSProperties;
    colorBtnStyle?: CSSProperties;
    paragraphIconStyle?: CSSProperties;
    dropdownContent: JSX.Element;
    tooltip?: any;
};

export const DRAWER_BACK_COLOR = 'drawer-back-color';

/**
 * 左侧按钮可点击触发事件，右侧为可点击的button
 */
export default class BackColorDropdown extends Component<IFormItemDropdownProps, IFormItemDropdownState> {
    public static getDerivedStateFromProps(props, state) {
        // 有更新的时候再刷新
        if (state.isChecked !== props.checked) {
            return {
                isChecked: props.checked,
            };
        }
        return null;
    }

    public constructor(props) {
        super(props);
        this.state = {
            isChecked: this.props.checked,
        };
    }

    public render() {
        const Component = this.props.dropdownContent;
        const wrapperClass = classNames({
            [Style['form-item-dropdown-wrapper']]: true,
            [Style['form-item-dropdown-wrapper-checked']]: this.state.isChecked,
        });
        const iconClass = classNames({
            [Style['form-item-icon']]: true,
            [Style['form-back-color']]: true,
        });
        return (<Tooltip {...getTooltipProps(this.props.tooltip)}>
            <div className={wrapperClass} style={this.props.style}>
                <div className={iconClass} onClick={this.props.onClick} style={this.props.paragraphIconStyle}>
                    <img src={this.props.icon} alt={''} style={{ marginTop: -1 }}/>
                    <div className={Style['form-back-color-btn']} style={this.props.colorBtnStyle}></div>
                </div>
                <Dropdown dropContent={this.props.dropdownContent}>
                    <div className={Style['form-item-dropdown-icon']} id={DRAWER_BACK_COLOR}>
                        <img src={DROPDOWN_ICON} alt={''}></img>
                    </div>
                </Dropdown>
            </div>
        </Tooltip>);
    }
}
